
export interface FoodDbItem {
    id: string;
    name: string;
    group: string;
    calories: number; // por 100g
    protein: number;  // por 100g
    carbs: number;    // por 100g
    fat: number;      // por 100g
    fiber: number;    // por 100g
    measures: {
      [key: string]: number; // e.g., { "unidade pequena": 80, "fatia": 25 } in grams
    };
  }
  
  export const foodDatabase: FoodDbItem[] = [
    {
      "id": "taco_001",
      "name": "Arroz, integral, cozido",
      "group": "Cereais e derivados",
      "calories": 124,
      "protein": 2.6,
      "carbs": 25.8,
      "fat": 1,
      "fiber": 2.7,
      "measures": {
        "colher de sopa": 20,
        "xícara": 150
      }
    },
    {
      "id": "taco_002",
      "name": "Feijão, carioca, cozido",
      "group": "Leguminosas e derivados",
      "calories": 76,
      "protein": 4.8,
      "carbs": 13.6,
      "fat": 0.5,
      "fiber": 8.5,
      "measures": {
        "concha média": 85,
        "xícara": 170
      }
    },
    {
      "id": "taco_003",
      "name": "Frango, filé, grelhado",
      "group": "Carnes e derivados",
      "calories": 163,
      "protein": 32,
      "carbs": 0,
      "fat": 3.5,
      "fiber": 0,
      "measures": {
        "filé pequeno": 100,
        "filé médio": 150
      }
    },
    {
      "id": "taco_004",
      "name": "Batata, inglesa, cozida",
      "group": "Tubérculos, raízes e derivados",
      "calories": 86,
      "protein": 1.9,
      "carbs": 20,
      "fat": 0.1,
      "fiber": 2.5,
      "measures": {
        "unidade pequena": 100,
        "unidade média": 180
      }
    },
    {
      "id": "taco_005",
      "name": "Ovo, de galinha, cozido",
      "group": "Ovos e derivados",
      "calories": 155,
      "protein": 13,
      "carbs": 1.1,
      "fat": 11,
      "fiber": 0,
      "measures": {
        "unidade": 50
      }
    },
    {
      "id": "taco_006",
      "name": "Alface, crespa, crua",
      "group": "Verduras, hortaliças e derivados",
      "calories": 15,
      "protein": 1.4,
      "carbs": 2.9,
      "fat": 0.2,
      "fiber": 1.4,
      "measures": {
        "folha": 5,
        "pires": 30
      }
    },
    {
      "id": "taco_007",
      "name": "Tomate, cru",
      "group": "Verduras, hortaliças e derivados",
      "calories": 18,
      "protein": 0.9,
      "carbs": 3.9,
      "fat": 0.2,
      "fiber": 1.2,
      "measures": {
        "fatia": 15,
        "unidade média": 120
      }
    },
    {
      "id": "taco_008",
      "name": "Maçã, fuji, com casca",
      "group": "Frutas e derivados",
      "calories": 56,
      "protein": 0.3,
      "carbs": 15,
      "fat": 0.2,
      "fiber": 2.4,
      "measures": {
        "unidade pequena": 130,
        "unidade média": 180
      }
    },
    {
      "id": "taco_009",
      "name": "Banana, prata",
      "group": "Frutas e derivados",
      "calories": 98,
      "protein": 1.3,
      "carbs": 26,
      "fat": 0.1,
      "fiber": 2,
      "measures": {
        "unidade pequena": 60,
        "unidade média": 100
      }
    },
    {
      "id": "taco_010",
      "name": "Leite, integral",
      "group": "Leite e derivados",
      "calories": 61,
      "protein": 3.2,
      "carbs": 4.8,
      "fat": 3.3,
      "fiber": 0,
      "measures": {
        "copo americano": 200,
        "xícara": 240
      }
    },
    {
      "id": "taco_011",
      "name": "Queijo, minas, frescal",
      "group": "Leite e derivados",
      "calories": 264,
      "protein": 17,
      "carbs": 1.6,
      "fat": 20,
      "fiber": 0,
      "measures": {
        "fatia": 30
      }
    },
    {
      "id": "taco_012",
      "name": "Pão, de forma, integral",
      "group": "Cereais e derivados",
      "calories": 253,
      "protein": 10,
      "carbs": 49,
      "fat": 4.3,
      "fiber": 6.9,
      "measures": {
        "fatia": 25
      }
    },
    {
      "id": "taco_013",
      "name": "Aveia, em flocos, crua",
      "group": "Cereais e derivados",
      "calories": 394,
      "protein": 13.9,
      "carbs": 66.6,
      "fat": 8.5,
      "fiber": 9.1,
      "measures": {
        "colher de sopa": 10
      }
    },
    {
      "id": "taco_014",
      "name": "Castanha-do-pará, crua",
      "group": "Nozes e outras oleaginosas",
      "calories": 656,
      "protein": 14,
      "carbs": 12,
      "fat": 66,
      "fiber": 7.5,
      "measures": {
        "unidade": 4
      }
    },
    {
        "id": "taco_015",
        "name": "Azeite de oliva, extra virgem",
        "group": "Óleos e gorduras",
        "calories": 884,
        "protein": 0,
        "carbs": 0,
        "fat": 100,
        "fiber": 0,
        "measures": {
          "colher de sopa": 8,
          "colher de chá": 2.5
        }
    },
    {
        "id": "taco_016",
        "name": "Salmão, grelhado",
        "group": "Pescados e frutos do mar",
        "calories": 208,
        "protein": 20,
        "carbs": 0,
        "fat": 13,
        "fiber": 0,
        "measures": {
          "posta pequena": 120,
          "posta média": 180
        }
    },
    {
        "id": "taco_017",
        "name": "Brócolis, cozido",
        "group": "Verduras, hortaliças e derivados",
        "calories": 34,
        "protein": 2.8,
        "carbs": 6.6,
        "fat": 0.4,
        "fiber": 2.6,
        "measures": {
          "ramo": 20,
          "xícara": 150
        }
    },
    {
        "id": "taco_018",
        "name": "Iogurte, natural, integral",
        "group": "Leite e derivados",
        "calories": 61,
        "protein": 3.5,
        "carbs": 4.7,
        "fat": 3.3,
        "fiber": 0,
        "measures": {
          "pote": 170
        }
    },
    {
        "id": "taco_019",
        "name": "Abacate",
        "group": "Frutas e derivados",
        "calories": 160,
        "protein": 2,
        "carbs": 8.5,
        "fat": 15,
        "fiber": 6.7,
        "measures": {
          "colher de sopa": 30,
          "fatia média": 50
        }
    },
    {
        "id": "taco_020",
        "name": "Mamão, formosa",
        "group": "Frutas e derivados",
        "calories": 45,
        "protein": 0.5,
        "carbs": 11.6,
        "fat": 0.1,
        "fiber": 1,
        "measures": {
          "fatia média": 100
        }
    }
  ]
